import { render, staticRenderFns } from "./ClientReportingManager.vue?vue&type=template&id=471c94bc&scoped=true"
import script from "./ClientReportingManager.vue?vue&type=script&lang=js"
export * from "./ClientReportingManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471c94bc",
  null
  
)

export default component.exports